import React, { Component } from "react";
import { shape, node, string } from "prop-types";

import * as i18nUtils from "util/i18n";

import LoansListItem from "pages/loans/ListItem";
import WidgetList from "pages/desktop/widgets/WidgetList";
import WidgetHeader from "./_components/WidgetHeader";

class Loans extends Component {
    static propTypes = {
        closeButton: node,
        draggableItemProps: shape({}).isRequired,
        goTo: string,
    };

    static defaultProps = {
        closeButton: null,
        goTo: "",
    };

    render() {
        const { closeButton, draggableItemProps, goTo } = this.props;
        const uiAutomationProp = { "data-ui-automation": "widgetLoans" };

        return (
            <WidgetList item={LoansListItem} keyExtractor={(item) => item.idProduct} name="loans">
                {(list) => (
                    <section
                        role="button"
                        className="widget"
                        {...uiAutomationProp}
                        {...draggableItemProps}
                        aria-roledescription={i18nUtils.get("desktop.widgets.message.roleDescription")}>
                        <WidgetHeader title={i18nUtils.get("menu.loans")} action={closeButton} goTo={goTo} />
                        {list}
                        <div className="overlay" />
                    </section>
                )}
            </WidgetList>
        );
    }
}

export default Loans;
